// Skrčen header (#stickyHeader.scrolled, stili v _main-nav.scss).
// Histereza: skrči pri scrollY > SCROLL_ON, razširi šele pri scrollY < SCROLL_OFF.
// Razlika mora biti večja od krčenja headerja (~45px): ker je header sticky (v toku),
// skrčenje skrajša dokument in brskalnik lahko scrollY zmanjša — z enim samim pragom
// bi se na kratkih straneh stanje preklapljalo sem ter tja.
const SCROLL_ON = 90
const SCROLL_OFF = 40

export default {
	init() {

		const header = document.getElementById("stickyHeader")

		if (header) {
			let ticking = false

			const update = () => {
				ticking = false

				// Med odprtim mobilnim menijem (mobile-menu.js zaklene body → scrollY = 0)
				// stanje headerja zamrzni, sicer se logo/sponzorji za panelom preskakujejo
				// in se po zaprtju scroll ne vrne na isti položaj.
				if (document.documentElement.classList.contains("main-nav-open")) return

				const y = window.scrollY
				if (y > SCROLL_ON) {
					header.classList.add("scrolled")
				} else if (y < SCROLL_OFF) {
					header.classList.remove("scrolled")
				}
			}

			window.addEventListener("scroll", () => {
				if (!ticking) {
					ticking = true
					requestAnimationFrame(update)
				}
			}, { passive: true })

			// začetno stanje: reload z ohranjenim položajem, skok na #sidro
			update()
		}
		
		var menuItems = document.querySelectorAll(".main-nav__list > li")
		
		var timeoutId
		var activeSubMenu
		
		menuItems.forEach((menuItem) => {
			menuItem.addEventListener("mouseenter", (e) => {
				if (window.innerWidth >= 1024) {
					clearTimeout(timeoutId)
					var currentSubMenu = menuItem.querySelector("ul")
					if (currentSubMenu) {
						currentSubMenu.classList.add("sub-menu-active")
						if (activeSubMenu && activeSubMenu !== currentSubMenu) {
							activeSubMenu.classList.remove("sub-menu-active")
						}
						activeSubMenu = currentSubMenu
		
						// Add menu item styles
						setMenuItemStyles()
		
					} else {
						activeSubMenu = null
						checkActiveSubmenus()
						setMenuItemStyles()
					}
				}
			})
		
			menuItem.addEventListener("mouseleave", (e) => {
				if (window.innerWidth >= 1024) {
					clearTimeout(timeoutId)
					timeoutId = setTimeout(() => {
						if (!isMouseOverSubMenu(e)) {
							if (activeSubMenu) {
								activeSubMenu.classList.remove("sub-menu-active")
								activeSubMenu = null
								setMenuItemStyles()
							}
						}
					}, 1000)
				}
			})
		
			// Adding mouseenter and mouseleave event listeners to sub-menu
			var subMenu = menuItem.querySelector("ul")
			if (subMenu) {
				subMenu.addEventListener("mouseenter", () => {
					if (window.innerWidth >= 1024) {
						clearTimeout(timeoutId)
						activeSubMenu = subMenu
						setMenuItemStyles()
						subMenu.classList.add("sub-menu-active")
					}
				})
				subMenu.addEventListener("mouseleave", () => {
					if (window.innerWidth >= 1024) {
						subMenu.classList.remove("sub-menu-active")
						activeSubMenu = null
						setMenuItemStyles()
					}
				})
			}
		})
		
		
		function checkActiveSubmenus() {
			if (activeSubMenu === null) {
				var subMenus = document.querySelectorAll(".sub-menu-active")
				subMenus.forEach((submenu) => {
					submenu.classList.remove("sub-menu-active")
				})
			}
		}
		
		function setMenuItemStyles() {
			if (activeSubMenu !== null) {
				menuItems.forEach((menuitem) => {
					if ( menuitem !== activeSubMenu.parentNode ) {
						menuitem.style.opacity = "0.4"
					} else {
						menuitem.style.opacity = "1"
					}
				})
		   } else {
			   menuItems.forEach((menuitem) => {
				   menuitem.style.opacity = "1"
			   })
		   }
		}
		
		// Function to check if the mouse is over the sub-menu or any of its parent menu items
		function isMouseOverSubMenu(e) {
			if (activeSubMenu) {
				var rect = activeSubMenu.getBoundingClientRect()
				return (
					e.clientX >= rect.left &&
					e.clientX <= rect.right &&
					e.clientY >= rect.top &&
					e.clientY <= rect.bottom
				)
			}
			return false
		}

	}
}
